import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import * as reactI18next from 'react-i18next';
import eurekaMgrs from '@eureka/ui-managers';
const { getConfig } = eurekaMgrs.ConfigManager;

const DEFAULT_UI5_LNG_MAPPING = {
  'de-DE': 'de',
  'en-US': 'en',
  'es-ES': 'es',
  'fr-FR': 'fr',
  'ja-JP': 'ja',
  'pt-BR': 'pt',
  'ru-RU': 'ru',
  'zh-CN': 'zh_CN',
  'cs-CZ': 'cs',
};

async function initI18n(config, options) {
  const isProduction = process.env.NODE_ENV === 'production';
  return (
    i18n
      // load translation using xhr -> see /public/locales
      // learn more: https://github.com/i18next/i18next-xhr-backend
      .use(HttpApi)
      // pass the i18n instance to react-i18next.
      .use(reactI18next.initReactI18next)
      // init i18next
      // for all options read: https://www.i18next.com/overview/configuration-options
      .init(
        Object.assign(
          {
            lng: 'en-US',
            defaultNS: 'shell',
            preload: ['en-US'],
            load: 'currentOnly',
            // fallbackLng: false,
            fallbackLng: 'en-US',
            fallbackNS: 'shell',
            debug: !isProduction, // true
            // Used to construct the resource path, so will affect case sensitive file systems
            lowerCaseLng: isProduction,
            react: {
              useSuspense: false,
            },
            interpolation: {
              escapeValue: false, // not needed for react as it escapes by default
            },
            detection: {
              order: ['path', 'localStorage'],
            },
            backend: {
              loadPath: (lng, ns) => {
                // for local testing
                const mockConfig = {
                  shell: 'http://localhost:2021',
                };

                // for prod
                // shell: 'https://cdn.eurekacloud.io/static/eureka-shell-ui/f1a9a5dcdce37e343b92022e29f79497af37a98a/';
                if (!config) {
                  console.log('config is null, please check');
                  config = mockConfig;
                }

                if (options.debug) {
                  console.log(lng[0], ns[0]);
                  console.log(config, options);
                }

                if (ns[0] !== '') {
                  return `${config[ns[0]]}/locales/{{lng}}/{{ns}}.json`;
                }

                return `${config['shell']}/locales/{{lng}}/{{ns}}.json`;
              },
              // allow cross domain requests
              crossDomain: true,
              // allow credentials on cross domain requests
              withCredentials: false,
              // overrideMimeType sets request.overrideMimeType("application/json")
              overrideMimeType: false,
            },
          },
          options,
        ),
      )
  );
}

const getCurrentLanguage = () => {
  if (i18n.debug) {
    console.log(i18n.language);
  }

  return i18n.language || window.localStorage.i18nextLng || '';
};

const setLanguage = (newLng, options) => {
  if (i18n.debug) {
    console.log(newLng, options);
  }

  i18n.changeLanguage(newLng);
  typeof window.zE === 'function' && window.zE('webWidget', 'setLocale', newLng);
};

const getUi5Language = lang => {
  const Ui5LngMapping = getConfig('ui5-lng-mapping');
  if (Ui5LngMapping && Object.keys(Ui5LngMapping).length > 0) {
    return Ui5LngMapping[lang] || 'en-US';
  }

  return DEFAULT_UI5_LNG_MAPPING[lang] || 'en-US';
};

const getUi5LanguageMapping = () => {
  return DEFAULT_UI5_LNG_MAPPING;
};

const getLocation = (manifest, component) => {
  const { cdn } = manifest.config;
  if (component?.port) {
    // http://localhost:2020
    return `${cdn}:${component?.port}`;
  } else {
    // https://cdn.eurekasap.io/eureka/shell-ui/dbbe6d4/
    return component?.location;
  }
};

export default {
  i18n,
  initI18n,
  getCurrentLanguage,
  setLanguage,
  getUi5Language,
  getUi5LanguageMapping,
  getLocation,
  ...reactI18next,
};
